import * as Yup from 'yup'

export const signatureValidator = Yup.object().shape({
    name: Yup.string().required('Campo obbligatorio'),
    surname: Yup.string().required('Campo obbligatorio'),
    position: Yup.string().required('Campo obbligatorio'),
    phone: Yup.string().required('Campo obbligatorio'),
    email: Yup.string().email('Email non valida').required('Campo obbligatorio')
})